import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import ET3Div from "../../../../../core/et3-div";
import Et3Image from "../../../../../core/et3-Image";
import Et3Text from "../../../../../core/et3-text";
import { E_MESSAGE_DELETION_STATUS } from "../../../../../Types";

const MessageHiddenIndicator = withLiteObserverAndTheme<{
  isDeleted: E_MESSAGE_DELETION_STATUS;
  deletedOn: string;
}>((props) => {
  const {
    theme: { colors },
    isDeleted,
    deletedOn
  } = props;

  switch (isDeleted) {
    case E_MESSAGE_DELETION_STATUS.HIDDEN_FROM_ME:
    case E_MESSAGE_DELETION_STATUS.HIDDEN_FROM_EVERYONE: {
      const imageName =
        isDeleted === E_MESSAGE_DELETION_STATUS.HIDDEN_FROM_ME
          ? "hide-from-me"
          : "hide-from-everyone";
      return (
        <ET3Div
          isScrollable={false}
          withShadow={false}
          isExtendable={true}
          height={0}
          width={80}
          color={colors.all.transparent}
          fDirection="column"
          justifyContent="center"
          alignItems="center"
          style={{}}
          onClick={() => {}}
        >
          <Et3Image
            type="LOCAL"
            alt={imageName}
            imageName={imageName}
            size={28}
            onClick={() => {}}
            style={{}}
          />
          <Et3Text
            fontFamily={"LIGHT"}
            fontSize={11}
            text={deletedOn}
            isSpan={false}
            color={colors.all.black}
            style={{}}
          />
        </ET3Div>
      );
    }
    default:
      return null;
  }
});
export default MessageHiddenIndicator;
